// @flow @format
import {handleActions} from 'lib/redux-actions';

import type {Repository} from 'lib/cloner-api';

export type State = {
	entities: {[id: ?string]: Repository},
	byMachine: {[machineId: ?string]: Repository[]},
};

export type FetchRepositoriesAction = {
	type: string,
	machineId: string,
	user: string,
};

type AddRepositoriesAction = {
	type: string,
	machineId: string,
	payload: Repository[],
};

// async actions
export const FETCH_REPOSITORIES = 'FETCH_REPOSITORIES';

export const fetchRepositories = (
	machineId: string,
	user: string
): FetchRepositoriesAction => ({
	machineId,
	user,
	type: FETCH_REPOSITORIES,
});

// actions
export const ADD_REPOSITORIES = 'ADD_REPOSITORIES';

export const addRepositories = (
	machineId: string,
	repositories: Repository[]
): AddRepositoriesAction => ({
	machineId,
	type: ADD_REPOSITORIES,
	payload: repositories,
});

export const initialState = {
	entities: {},
	byMachine: {},
};

const reducer = handleActions(
	{
		[ADD_REPOSITORIES]: (
			state: State,
			action: AddRepositoriesAction
		): State => {
			const entities = {...state.entities};
			const byMachine = {...state.byMachine};

			byMachine[action.machineId] = [];

			for (const repository of action.payload) {
				entities[repository.id] = repository;
				byMachine[action.machineId].push(repository);
			}

			return {...state, entities, byMachine};
		},
	},
	initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/entities/repositories.js